<template>
    <!-- 外层容器：设置全局背景色 -->
    <div class="protocol-page-wrapper">
        <!-- 主体容器：保持原有宽度 -->
        <div class="protocol-container">
            <!-- <el-button type="text" @click="goLogin" style="float: left;color: #999;" icon="el-icon-arrow-left">
                返回登录页
            </el-button> -->
            <div class="protocol-header">
                <h1>权利通知规则</h1>
            </div>
            <div class="protocol-content">
                <!-- 这里放置服务协议的具体内容 -->
                <div class="protocol-section">
                    <h2>一、通知规则</h2>
                    <p>任何个人或单位如果发现智步云上模型网上交易平台的网络用户上传的文件侵害其合法权益，请上述个人或单位务必以书面的通讯方式向智步云上模型网上交易平台提交权利通知。
                    </p>
                    <p> 为了有效处理上述个人或单位的权利通知，建议在权利通知中使用以下格式和内容：
                    </p>
                    <p>1.
                        权利人对涉嫌侵权内容拥有著作权或其他合法权益的权属证明或您可以合法使用该作品或该内容的证明。例如，著作权登记证书、商标证书、作品首次公开发表链接或证明、权威机构签发的时间戳等权属证明。以及对侵权行为的具体列明。
                    </p>
                    <p>2. 请充分、明确地描述侵犯了权利人合法权益的内容并请提供非法上传该作品的网址。</p>
                    <p>3. 请指明涉嫌侵权网页的哪些内容侵犯了第2项中列明的权利人的合法权益。</p>
                    <p>4.
                        请提供权利人主体信息和相关资料：姓名/名称、联系方式、地址、电子邮箱、身份证或护照复印件（对自然人）、营业执照（对单位），若委托代理人进行侵权投诉的，还需提交代理人的具体实名信息以及代理证明。
                    </p>
                    <p>5. 请在权利通知中加入如下关于通知内容真实性的声明：</p>
                    <p> “我本人/本公司为所投诉内容的合法权利人；在我举报的上传人网页上登载的内容侵犯了本人/本公司相应的合法权益。本人/本公司确认：如果本权利通知内容不完全属实，本人/本公司将承担由此产生的一切法律责任。”
                    </p>
                    <p>6. 请在权利通知中加入以下陈述：“我/本公司保证，本通知中所述信息是充分、真实、准确的，我/本公司是所投诉内容的合法权利人，或，我/本公司已获授权，有权行使第2项中列明内容的权益。”</p>
                    <p>7.
                        如您需要智步云上模型网上交易平台提供该涉嫌侵权的上传人的实名认证信息，请在权利通知中明确声明，并作出以下承诺：“我/本公司取得上传人的身份信息和联系方式后，保证仅用于向上传人/本公司追究侵权责任，否则由本人/本公司承担由此产生的一切法律责任”。
                    </p>
                    <p>8. 请您签署该文件，如果您是依法成立的机构或组织，请您加盖公章。</p>
                    <p>请注意：如果权利通知的陈述失实，权利通知提交者将承担对由此造成的全部法律责任（包括但不限于赔偿各种费用及律师费）。如果上述个人或单位不确定网络上可获取的资料是否侵犯了其合法权益，建议该个人或单位首先咨询专业人士。
                    </p>
                    <p>请您把以上资料扫描或拍照后通过邮件发往以下邮箱：zhibuyunshang@swocs.com.cn。
                    </p>
                    <p>智步云上模型网上交易平台在收到您提交的上述资料，并经审核后，认为上传人确有侵权嫌疑的，将为您移除相关侵权内容，并按您的请求向您提供上传人的实名认证信息和联系方式。</p>
                    <p>智步云上模型网上交易平台一直致力于保护原创作品，感谢您参与平台内容治理，我们将尽快回复及处理您的邮件。</p>
                    <p>我们为保护原创作品采取的措施：</p>
                    <p>1.加强审核培训，严格把好审核关</p>
                    <p>2.建立信用系统，扶持优质设计师，打击失信设计师。</p>
                    <p>3.提供畅通的投诉渠道及快速处理机制</p>
                    <p>4.开发基于图像识别的查重系统，尽力避免被投诉过的内容再次上传</p>
                </div>
                <div class="protocol-section">
                    <h2>二、反通知规则</h2>
                    <p>智步云上模型网上交易平台根据前述通知移除相关内容或上传人链接的，被移除内容的内容提供者或被移除上传人链接的管理人可以依法向智步云上模型网上交易平台发出关于被移除内容不侵犯著作权或其他合法权益的反通知。反通知发出后，智步云上模型网上交易平台经形式审查后可以恢复被移除的内容或链接，且依法对该恢复行为不承担法律责任。
                    </p>
                    <p>为了便于我们处理您的反通知，反通知资料中应当包括但不限于以下内容，如有缺漏，可能导致智步云上模型网上交易平台无法处理您的反通知：</p>
                    <p>1. 请指明被智步云上模型网上交易平台移除的信息或内容及其网址。</p>
                    <p>2.
                        被移除内容的合法性证明，包括但不限于您对已移除的内容拥有著作权或其他合法权益的权属证明或您可以合法使用该作品或该内容的证明。例如，著作权登记证书、商标证书、作品首次公开发表链接或证明、权威机构签发的时间戳等权属证明。
                    </p>
                    <p>3.您的主体信息和相关资料： 姓名/名称、联系方式、地址、电子邮箱、身份证或护照复印件（对自然人）、营业执照（对单位），若委托代理人进行申诉的，还需提交代理人的具体实名信息以及代理证明。</p>
                    <p>4. 请在反通知中加入如下关于反通知内容真实性的声明：</p>
                    <p>“我本人/本公司为该作品/该内容的合法权利人；我/我司有权或已获授权提供或刊登上述被移除的信息或内容。本人/本公司确认：如果本“反通知”内容不完全属实，本人/本公司将承担由此产生的一切法律责任。”
                    </p>
                    <p>5. 请在反通知中加入以下陈述：“我/本公司保证，本反通知中所述信息是充分、真实、准确的，我/本公司是该作品/该内容的合法权利人，或我/本公司已获授权或依法可以使用第1项中列明作品/内容。”
                    </p>
                    <p>6. 请您签署该文件，如果您是依法成立的机构或组织，请您加盖公章。</p>
                    <p>您可以通过智步云上模型网上交易平台网站首页联系我们底部中提供的申诉邮箱发送反通知相关资料。
                    </p>
                </div>
                <!-- 更多协议内容... -->
            </div>
        </div>
        <!-- 底部版权：固定在页面底部 -->
        <div class="protocol-footer-wrapper">
            <!-- <Bottom></Bottom> -->
        </div>
    </div>
</template>

<script>
import Bottom from '../../components/Footer.vue';
export default {
    name: 'PrivacyPolicy',
    components: {
        Bottom
    },
    methods: {
        goLogin() {
            this.$router.push('/Login');
        },
    }
}
</script>

<style lang="less" scoped>
// 页面外层容器：设置全局背景色，确保占满整个视口
.protocol-page-wrapper {
    width: 100%;
    min-height: 100vh;
    background-color: #232323; // 两侧背景色
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

// 主体容器：保持原有宽度，内容居中
.protocol-container {
    max-width: 1200px;
    width: 100%;
    margin: 0 auto;
    padding: 30px;
    box-sizing: border-box; // 确保padding不影响宽度
    flex: 1; // 占满除底部外的剩余空间
}

.protocol-header {
    text-align: center;
    margin-bottom: 30px;
    padding-bottom: 20px;
    border-bottom: 1px solid #444; // 适配深色背景的分隔线

    h1 {
        font-size: 24px;
        color: #E3E3E3;
        font-weight: 600;
    }
}

.protocol-content {
    font-size: 16px;
    line-height: 1.8;
    color: #ACACAC;

    .protocol-section {
        margin-bottom: 25px;

        h2 {
            font-size: 18px;
            color: gainsboro;
            margin-bottom: 10px;
            font-weight: bold;
        }

        p {
            margin-bottom: 10px;
            text-indent: 2em;
        }
    }
}
</style>